import React, { useEffect, useState } from 'react';
import { Smartphone } from 'lucide-react';

interface KeepScreenOnBadgeProps {
  className?: string;
}

export function KeepScreenOnBadge({ className = '' }: KeepScreenOnBadgeProps) {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Only show on mobile devices
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    setIsVisible(isMobile);
  }, []);

  if (!isVisible) {
    return null;
  }

  return (
    <div className={`inline-flex items-center gap-2 px-3 py-1.5 bg-green-50 text-green-700 rounded-full text-xs font-medium border border-green-200 ${className}`}>
      <Smartphone className="w-3 h-3" />
      <span>Screen stays on</span>
    </div>
  );
}
